module.exports = __webpack_public_path__ + "img/KZ.053cc91d.svg";